<script lang="ts">
    export let steps = [];
    export let step = 0;
    export let color = '';
</script>
<section>
    <div class="back-gray box-l radius py-1 px-15 w-max-content">
        {#each steps as item, index (item)}
            <div class="text-c step" class:next={index < steps.length - 1} class:active={index < step}>
                <div class="box step-icon relative">
                    {#if index > step}
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                             fill="#DFE1E5">
                            <path d="M0 0h24v24H0V0z" fill="none"/>
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
                        </svg>
                    {/if}

                    {#if index === step}
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                             fill="{color}">
                            <path d="M0 0h24v24H0V0z" fill="none"/>
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
                            <circle cx="12" cy="12" r="5"/>
                        </svg>
                    {/if}

                    {#if index < step}
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                             fill="{color}">
                            <path d="M0 0h24v24H0V0z" fill="none"/>
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z"/>
                        </svg>
                    {/if}
                </div>
                <p>{item}</p>
            </div>
        {/each}
    </div>
</section>
<style>
    .step{
        max-width: 120px;
        width: 120px;
        position: relative;
    }
    .step.next .step-icon:after{
        position: absolute;
        content: '';
        background: #DFE1E5;
        display: block;
        width: 100px;
        height: 2px;
        left:70px;
    }

    .step.next.active .step-icon:after{
        background: var(--secondary);
    }

    .step p{
        font-size: 14px;
        color: var(--text-gray);
    }
</style>